import styled from 'styled-components';

export const CustomListStyled = styled.div`
    /* .MuiAutocomplete-listbox .MuiAutocomplete-option {
        display: flex;
        justify-content: space-between;
    } */
    li {
        display: flex;
        flex-direction: row-reverse;
        text-align: left;
        span {
            flex: 1;
        }
    }
    .badge {
        flex: inherit;
        font-weight: 600;
        background-color: #f0f4f9;
        color: #303641;
        padding: 5px 10px;
        border-radius: 6px;
        margin-left: 5px;
        text-align: center;
        min-width: 3.5em;
    }
    .MuiPaper-root {
        width: 400px;
    }
    @media only screen and (max-width: 600px) {
        .MuiPaper-root {
            width: 100%;
        }
    }
`;
export const CustomListBox2Styled = styled.div`
    .last-search-area {
        padding: 16px;
        .cardArea {
            position: relative;

            .closeButton {
                position: absolute;
                top: 5px;
                right: 5px;
                bottom: 0;
                margin: auto;
                z-index: 2;
                svg {
                    width: 18px;
                    height: 18px;
                }
            }
        }
        .title {
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 15px;
        }
        .card {
            cursor: pointer;
            padding: 10px;
            margin: auto;
            position: relative;
            margin-bottom: 10px;
            background-color: var(--mui-palette-background-background1);
            border-radius: 6px;
            .cardContent {
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                padding: 10px;
                .leftCard {
                    display: flex;
                    gap: 12px;
                    font-size: 12px;
                    svg {
                        width: 18px;
                        height: 18px;
                    }
                }
            }
            .cardInfo {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                padding: 8px 10px;
                align-items: center;
                font-size: 10px;
                line-height: 140%;
                gap: 5px;

                .line {
                    border-left: 2px solid var(--mui-palette-text-secondary);
                    height: 12px;
                    opacity: 0.3;
                }
                .event-icon {
                    width: 14px;
                    height: 14px;
                }
                & > div {
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    gap: 5px;
                }
            }
        }
        .cities-buttons {
            div {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                flex-wrap: wrap;
                flex-direction: row;
                justify-content: space-around;
                gap: 12px;
                margin-bottom: 15px;
                button {
                    width: 100%;
                    text-transform: capitalize;
                    background-color: var(--mui-palette-background-background1);
                    border-color: transparent;
                    font-size: 14px;
                    color: var(--mui-palette-text-secondary);
                    &:hover {
                        border-color: var(--mui-palette-primary-main);
                    }
                }
            }
        }
    }
    .MuiPaper-root {
        width: 400px;
    }
    @media only screen and (max-width: 600px) {
        .MuiPaper-root {
            width: 100%;
        }
    }
`;

export const PassengerCardStyled = styled.div`
    .passengerCard {
        padding: 10px 20px;
        .passengerCardContent {
            display: flex;
            flex-direction: row;
            align-items: center;
            .label {
                flex: 1;
                font-size: 14px;
                font-weight: 500;
                color: var(--mui-palette-text-primary);
                span {
                    font-size: 10px;
                    color: var(--mui-palette-text-secondary);
                }
            }
            .buttons {
                display: flex;
                flex-direction: row;
                color: var(--mui-palette-text-disabled);
                align-items: center;
                .count {
                    width: 30px;
                    text-align: center;

                    color: var(--mui-palette-text-primary);
                }
            }
        }
    }
`;
export const PageStyled = styled.div`
    flex: 1;

    .form-area {
        width: 100%;
        padding-left: 10px;
        .error-date {
            color: var(--mui-palette-error-main);
            font-weight: 400;
            font-size: 12px;
            padding-left: 15px;
            padding-top: 3px;
            margin: 0px;
        }
        .date-buttons {
            background-color: #fff;
            min-height: 56px;
            color: #646a76;
            display: flex;
            justify-content: space-between;
        }
        .active {
            background-color: #e3f1f6;
            color: #0098c2;
        }
    }

    .change-button {
        color: #fff;
        background-color: #36739e !important;

        position: absolute;
        right: -20px;
        top: 5px;
        bottom: 0;
        margin: auto;
        height: 32px;
        width: 32px;
        z-index: 1;
    }
    .right-padding {
        .MuiInputLabel-root,
        .MuiInputAdornment-positionEnd {
            padding-right: 10px;
        }
    }
    .left-padding {
        .MuiInputLabel-root,
        .MuiInputBase-input {
            padding-left: 10px !important;
        }
    }

    /* .checkbox-white {
        left: 2px;
        position: relative;
    }
    .checkbox-white,
    .checkbox-white .MuiButtonBase-root {
        color: #fff;
        user-select: none;
    }
    .button-group {
        margin-bottom: 10px;
        .MuiButtonBase-root {
            background-color: rgb(255 255 255 / 20%);
            color: #fff;
            padding: 12px 25px;
            &.active {
                background-color: var(--mui-palette-secondary-main);
            }
        }
    } */

    .custom-autocomplete-list-box {
        .badge {
            background-color: #f0f4f9;
            color: #303641;
            padding: 5px 10px;
            border-radius: 6px;
        }
    }
    .passengerBox {
        position: relative;
    }
    .detail-close {
        margin-top: 5px;
        .relative-isOneWay {
            position: relative;

            .checkbox-isOneWay {
                position: absolute;
                top: -25px;
                right: 0;
                margin: 0;
            }
        }
    }

    .relative-isOneWay {
        position: relative;
    }
    .ghostDatePicker-control + .ghostDatePicker {
        background-color: transparent;
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        bottom: 0;
        z-index: 2;
    }

    @media only screen and (max-width: 1200px) {
        .custom-input-passenger {
            /* max-width: 100%; */
        }
    }
    /* @media only screen and (max-width: 900px) {
        .custom-grid {
            gap: 0px;
            flex-direction: column;
            & > *:first-child {
                width: calc(100% + 10px);
            }
            & > * {
                width: 100%;
                flex: 1;
            }
        }
    } */
    @media only screen and (max-width: 900px) {
        .custom-grid {
            flex-direction: column;
            & > *:first-child {
                width: calc(100% + 10px);
            }
            & > * {
                width: 100%;
                flex: 1;
            }
            .change-button {
                color: rgb(255, 255, 255);
                transform: rotate(90deg);
                position: absolute;
                right: 7px;
                top: 65px;
                margin: auto;
                height: 32px;
                width: 32px;
                z-index: 1;
                background-color: rgb(54, 115, 158) !important;
            }
            .right-padding {
                .MuiInputLabel-root,
                .MuiInputAdornment-positionEnd {
                    padding-right: 0px;
                }
            }
            .left-padding {
                .MuiInputLabel-root,
                .MuiInputBase-input {
                    padding-left: 0px !important;
                }
            }
        }
    }
`;
